/* eslint-disable import/prefer-default-export */

export enum TooltipId {
  CONTROL_ROOMS = "ControlRooms",
  PREVIEW_STREAM = "PreviewStream",
  STREAM = "Stream",
  GO_LIVE = "GoLive",
  GO_CONTROL_ROOM = "GoControlRoom",
  CREATE_EVENT = "CreateEvent",
}
